// extracted by mini-css-extract-plugin
export default {"cadastrar":"cadastro_cadastrar__86bwA","forme":"cadastro_forme__+hFjE"};